
<template>
  <div class="chart-container">
    <div class="cylinder" :class="mobiles">
      <div class="cylinder-centont" :class="item.zdf<0?'minus':'plus'" v-for="(item,index) in datas" @click="ckxq(index)" :key="index" :style="{height:item.height+'px'}">
        <span class="cylinder-t"></span>
        <span class="cylinder-l"></span>
        <span class="cylinder-r"></span>
        <span class="cylinder-num">{{ item.percentage }}%</span>
        <span class="cylinder-name">{{ item.dl }}</span>
        <div class="cylinder-tit">
          <p><label>时间：</label>{{ item.dy }}</p>
          <p><label>指标名称：</label>{{ item.jtdzbmc }}</p>
          <p><label>月均值：</label>{{ (item.dyyjz).toFixed(2) }}</p>
          <p><label>上月均值：</label>{{ (item.syyjz).toFixed(2) }}</p>
          <p><label>涨跌福：</label>{{ (item.zdf).toFixed(2) }}</p>
          <p><label>月总和：</label>{{ (item.dyzh).toFixed(2) }}</p>
        </div>
      </div>
      <div class="max-min">
        <p title="当月最高值"><i></i>{{ dyzgz }}</p>
        <p title="当月最低值"><i></i>{{ dyzdz }}</p>
      </div>
    </div>
    <div class="visit-ranking" style="display: none">
      <div id="bigData" style="width: 100%; height: 100%; display: none"></div>

      <div class="pillars" >
        <div class="lui-column-bg">
          <span class="nums">76</span>
          <font class="titles">粘胶</font>
        </div>
        <div class="lui-column-bg">
          <span class="nums">76</span>
          <font class="titles">锦纶</font>
        </div>
        <div class="lui-column-bg">
          <span class="nums">76</span>
          <font class="titles" style="bottom: -45px">涤纶长丝</font>
        </div>
        <div class="lui-column-bg" style="height: 45px; margin-top: 45px">
          <span class="nums">76</span>
          <font class="titles" style="bottom: -45px">涤纶短丝</font>
        </div>
        <div class="lui-column-bg fall" style="height: 35px">
          <span class="nums">76</span>
          <font class="titles">丙纶</font>
        </div>
        <div class="lui-column-bg fall">
          <span class="nums">76</span>
          <font class="titles">氨纶</font>
        </div>
        <div class="lui-column-bg fall">
          <span class="nums">76</span>
          <font class="titles">腈纶</font>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
import * as echarts from 'echarts';
export default {
  name: 'chart',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    countTo
  },
  data () {
    return {
      dyzgz:0,
      dyzdz:0,
      mobiles:'',
      datas:[]
    }
  },
  mounted () {
    let $this=this
    $this.getdata()
    // this.initcolumnar()
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.getdata()
    })
  },
  methods: {
    getdata () {
      let $this=this
      let year= new Date().getFullYear()
      let month= new Date().getMonth()
      month=month<10?'0'+month:month
      let times=year+'-'+month
      if(month=='00'){
        times=(year-1)+'-12'
      }
      const url = '/api-portal/ccf/priceList/list';
      this.$api.post(url, {monthEnd:times,monthStart:times}, (response) => {
        let datas=response.data||''
        if(datas){
          let zdz=0,zxz=0,fzgs=0;
          let arr=[]
          for (var i=0;i<7;i++){
            const zdf=datas[i].zdf
            const dyyjz=datas[i].dyyjz
            const syyjz=datas[i].syyjz
            if(zdf<0){
              fzgs++
              const nu=(1-(dyyjz/syyjz)).toFixed(4)
              zxz=zxz>=nu?zxz:nu
            }else {
              const nu=((dyyjz/syyjz)-1).toFixed(4)
              zdz=zdz>=nu?zdz:nu
            }
          }
          $this.mobiles=fzgs==0?'mobile-down':'' //(fzgs==1?'mobile-downl':'')
          for(var j=0;j<7;j++){
            let vals=datas[j]
            const dyyjz=vals.dyyjz
            const syyjz=vals.syyjz
            const zdf=vals.zdf
            if(zdf<0){
              let nu=(1-(dyyjz/syyjz)).toFixed(4)
              let heights=(nu/zxz)*(fzgs==7?110:103)
              heights=heights<25?25:heights
              vals['height']=heights
              vals['percentage']=(nu*(-100)).toFixed(2)
            }else {
              let nu=((dyyjz/syyjz)-1).toFixed(4)
              let heights=(nu/zdz)*(fzgs==0?110:103)
              heights=heights<25?25:heights
              vals['height']=(zdf==0||nu*100<0.009)?0:heights
              vals['percentage']=(nu*100).toFixed(2)
            }
            if(j==0){
              arr.push(vals)
            }
            for(var k=0;k<j;k++){
              const per=arr[k].percentage
              if((vals.percentage)*1>per*1){
                let temp=arr[k]
                arr[k]=vals
                vals=temp
              }
              if(k==j-1){
                arr.push(vals)
              }
            }
          }
          $this.datas=arr
          this.dyzgz=this.datas[0].dyzgz
          this.dyzdz=this.datas[0].dyzdz
        }
      },'json')
    },
    ckxq (num) {
      this.dyzgz=this.datas[num].dyzgz
      this.dyzdz=this.datas[num].dyzdz
    },
    initcolumnar(){
      this.chart = echarts.init(document.querySelector('.visit-ranking #bigData'));
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '4%',
          containLabel: true
        },
        toolbox: {

        },
        xAxis: {
          type: 'category',
          data: ['化纤','化纤1','化纤短丝','化纤3','化纤4','化纤5','化纤6'],
          axisLabel: {
            textStyle: {
              color: 'rgba(255, 255, 255, 0.65)'
            },
          }
        },
        yAxis: {
          show:false
        },
        series: [
          {
            name: '教师',
            type: 'bar',
            data: [70,30,50,-15,40,-18,16],
            barWidth: 30,
            label: {
              show: true, // 柱子顶部的数值
              position: 'top',//
              top: 0,
              fontSize: 16,
              fontWeight: 'bold',
              offset: [0, 0],
              textStyle: {
                color: 'rgba(255, 255, 255, 0.85)'
              }
            },
            itemStyle: {
              normal: {
                color: (val)=>{
                  var index_num=val.value
                  return index_num>0?'#D90000':'#00B050'
                }
              }
            },
          }, {
            type: 'bar', //右侧浅色区域，右侧边框，形成立体图形
            barWidth: 9,
            itemStyle: {
              normal: {
                color: (val)=>{
                  var index_num=val.value
                  return index_num>0?'#BD0000':'#009141'
                }
              }
            },
            barGap: 0,
            data: [70,30,50,-15,40,-18,16].map(item => item + 1)
          },
          { //顶部的矩形，封顶
            name: 'b',
            tooltip: {
              show: false
            },
            type: 'pictorialBar',
            itemStyle: {
              borderWidth: 0,
              borderColor: (val)=>{
                var index_num=val.value
                return index_num>0?'#FD0000':'#00B050'
              },
              color: (val)=>{
                var index_num=val.value
                return index_num>0?'#FD0000':'#00B050'
              },
            },
            symbol: 'path://M 0,0 l 120,0 l -20,60 l -120,0 z',
            symbolSize: ['37', '4'],
            symbolOffset: ['-1', '-1'], // 左右 ，上下
            symbolRotate: 0,
            symbolPosition: 'end',
            data: [70,30,50,-15,40,-18,16],
            z: 3
          }
        ]
      };
      this.chart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.visit-ranking{
  height: 210px;
  padding: 0 30px;
  width: calc(100% - 60px);
}

.pillars{
  display: flex;
  justify-content: space-around;
  padding: 0 45px;
  margin-top: 82px;
  position: relative;
}

.pillars::after {
  content: '';
  position: absolute;
  top: 100px;
  background: #07465F;
  width: 85%;
  height: 1px;
}

.lui-column-bg {
  position: relative;
  width: 32px;
  height: 90px;
  background-color: transparent;
  background-color: rgba(189, 0, 0, 1);
  -webkit-transition: height 2s;
}
.lui-column-bg:before {
  position: absolute;
  content: '';
  display: block;
  height: 20px;
  width: 100%;
  border-radius: 50%;
  top: -10.5px;
  z-index: 1;
  background-color: rgb(217, 0, 0);
}

.lui-column-bg:after {
  position: absolute;
  content: '';
  display: block;
  height: 15px;
  width: 100%;
  border-radius: 50%;
  bottom: -10px;
  background-color: rgb(217, 0, 0);
}

.nums{
  font-size: 16px;
  font-family: 微软雅黑;
  color: #fff;
  position: absolute;
  top: -22px;
  width: 100%;
  text-align: center;
  z-index: 3;
  font-weight: bold;
  text-shadow: 2px 3px 4px rgba(0,0,0,.4);
}

.titles{
  color: #fff;
  font-size: 14px;
  transform:rotate(45deg);
  position: absolute;
  bottom: -38px;
  white-space: nowrap;
  text-align: center;
  z-index: 3;
}

.fall{
  transform:rotate(180deg);
  background-color: rgba(0, 145, 65, 1);
  margin-top: 110px;
  height: 65px;
}

.fall:before{
  background-color: rgb(0, 176, 80);
}

.fall:after {
  background-color: rgb(0, 176, 80);
}
.fall .nums{
  transform:rotate(180deg);
  top: 0px;
}
.fall .titles{
  transform:rotate(180deg);
}

.cylinder{
  position: relative;
  width: 400px;
  height: 1px;
  border-top: 1px solid #07465F;
}

.cylinder-centont{
  width: 37px;
  position: absolute;
  letter-spacing:-3px;
  font-size: 0;
  cursor: pointer;
  transition: height 2s;
}

.cylinder-centont:nth-child(2){
  left: 60px;
}

.cylinder-centont:nth-child(3){
  left: 120px;
}

.cylinder-centont:nth-child(4){
  left: 180px;
}

.cylinder-centont:nth-child(5){
  left: 240px;
}

.cylinder-centont:nth-child(6){
  left: 300px;
}

.cylinder-centont:nth-child(7){
  left: 360px;
}

.cylinder-centont span{
  display: inline-block;
  margin: 0;
}

.cylinder-l{
  height: calc(100% - 3px);
  width: 30px;
  position: absolute;
  left: 0px;
  top: 3px;
}

.cylinder-r{
  height: 100%;
  width: 7px;
  clip-path: polygon(0 1px, 0 100%, 7px 92%,7px -4px);
  transition: 1s clip-path;
  position: absolute;
  left: 29px;
  top: 1px;
}

.cylinder-t{
  width: 37px;
  height: 4px;
  clip-path: polygon(7px 0px, 0 4px, 30px 4px,44px -4px);
  transition: 1s clip-path;
}

.cylinder-num{
  font-size: 16px;
  font-family: 微软雅黑;
  color: #fff;
  position: absolute;
  top: -17px;
  left: -25px;
  width: 87px;
  text-align: center;
  letter-spacing:1px;
  z-index: 3;
  font-weight: bold;
  text-shadow: 2px 3px 4px rgba(0,0,0,.4);
}

.cylinder-name{
  color: #fff;
  font-size: 14px;
  transform:rotate(45deg);
  position: absolute;
  bottom: -34px;
  left: 0;
  white-space: nowrap;
  text-align: center;
  letter-spacing:0px;
}

.plus{
  bottom: 0;
}

.plus .cylinder-l{
  background: #D90000;
}

.plus .cylinder-r{
  background: #BD0000;
}

.plus .cylinder-t{
  background: #FD0000;
}

.minus .cylinder-l{
  background: #00B050;
  top: 0;
}

.minus .cylinder-r{
  background: #009141;
  clip-path: polygon(0 0px, 0 98%, 7px 90%,7px 0px);
  top: 0;
}

.minus .cylinder-t{
  display: none;
}

.minus .cylinder-num{
  bottom: 6px;
  top: auto;
}

.minus .cylinder-name{
  top:-22px;
  bottom: auto;
  transform:rotate(0deg);
}

.max-min{
  min-width: 108px;
  position: absolute;
  right: -15px;
  top: -122px;
}

.mobile-down .max-min{
  top:auto;
  right: -21px;
  bottom: -132px;
}

.mobile-downl .max-min{
  top:auto;
  right: auto;
  left: -21px;
  bottom: -132px;
}

.max-min p{
  min-width: 100%;
  padding: 0 3px;
  height: 40px;
  background: url("../../../assets/bj-1.png") no-repeat center/100%;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-around;
  align-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #FF175C;
}

.max-min p i{
  width: 26px;
  height: 30px;
  background: url("../../../assets/icon-1.png") no-repeat center/100%;
}

.max-min p:nth-child(2){
  color: #FFE602;
}

.max-min p:nth-child(2) i{
  background: url("../../../assets/icon-2.png") no-repeat center/100%;
}

.cylinder-tit{
  background: rgba(0,45,134,0.84);
  border: 1px solid #2F86F0;
  padding: 8px;
  position: absolute;
  left: 30px;
  top: 15%;
  z-index: 98;
  letter-spacing:0px;
  min-width: 100px;
  border-radius: 4px;
  display: none;
}

.plus .cylinder-tit{
  top: auto;
  bottom: 15%;
}

.cylinder-centont:hover .cylinder-tit{
  display: block;
}

.cylinder-tit p{
  font-size: 12px;
  color: #fff;
  line-height: 165%;
  white-space: nowrap;
}

.cylinder-tit p label{
  width: 66.5px;
  display: inline-block;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/left-module-four.vue